import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ReferrerCapture = () => {
  const navigate = useNavigate();
  const [refLink, setRefLink] = useState("");
  const [showReward, setShowReward] = useState(false);
  const [error, setError] = useState("");

  const handleProceed = (event) => {
    event.preventDefault();
    const trimmed = refLink.trim();
    if (!trimmed) {
      setError("Please enter your referrer link.");
      return;
    }
    setError("");
    setShowReward(true);
  };

  const handleSkip = () => {
    navigate("/packages");
  };

  useEffect(() => {
    if (!showReward) return;
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 2000);
    return () => clearTimeout(timer);
  }, [showReward, navigate]);

  return (
    <section className="w-full min-h-screen relative bg-black overflow-hidden font-[Poppins]">

      {/* Top Shadow Image */}
      <img
        src="images/top.png"
        alt="Top Shadow"
        className="absolute top-0 left-1/2 -translate-x-1/2 z-0 opacity-60 w-full max-w-lg sm:max-w-2xl"
      />

      {/* Left Corner */}
      <img
        src="images/leftcorner.png"
        alt="Left Corner"
        className="hidden md:block absolute bottom-0 left-0 z-0 opacity-80 w-48 sm:w-56 md:w-64 lg:w-72"
      />

      {/* Right Corner */}
      <img
        src="images/right-corner.png"
        alt="Right Corner"
        className="hidden md:block absolute bottom-0 right-0 z-0 opacity-80 w-48 sm:w-56 md:w-64 lg:w-72"
      />

      {/* Left Coin */}
      <img
        src="images/synergy.png"
        alt="Left Coin"
        className="absolute left-4 sm:left-12 top-1/2 -translate-y-1/2 z-10 w-16 h-16 sm:w-28 sm:h-28 md:w-40 md:h-40 opacity-80"
      />

      {/* Right Coin */}
      <img
        src="images/synergy.png"
        alt="Right Coin"
        className="absolute right-4 sm:right-12 top-1/3 -translate-y-1/2 z-10 w-12 h-12 sm:w-20 sm:h-20 md:w-28 md:h-28 opacity-80"
      />

      {/* Background Overlay when Reward is visible */}
      {showReward && (
        <div className="pointer-events-none absolute inset-0 z-[5] bg-black/45 backdrop-blur-sm" />
      )}

      {/* Content */}
      <div className="relative z-20 min-h-screen flex flex-col">

        {/* Header */}
        <div className="flex justify-between items-center p-4 sm:p-6">
          <img src="images/login-logo.png" alt="Logo" className="max-h-10 sm:max-h-12" />
          <button
            onClick={() => navigate("/login")}
            className="text-white hover:text-purple-400 text-sm sm:text-base transition"
          >
            Login
          </button>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6">
          {showReward ? (
            // ✅ Reward Card
            <div className="relative z-10 flex w-full max-w-md flex-col items-center gap-6 rounded-[32px] border border-white/10 bg-gradient-to-br from-[#240F35] via-[#15113A] to-[#0B142D] p-8 sm:p-12 text-center shadow-[0_60px_140px_rgba(43,19,110,0.55)] backdrop-blur-[32px]">
              <div className="relative h-32 w-32 sm:h-36 sm:w-36">
                <div className="absolute inset-0 rounded-[28px] bg-gradient-to-br from-[#8D61FF] via-[#94A0FF] to-[#4E67FF] shadow-[0_25px_60px_rgba(118,78,255,0.45)]" />
                <div className="absolute inset-0 rounded-[28px] border border-white/10" />
                <span className="absolute inset-x-[43%] inset-y-3 block rounded-full bg-white/70 shadow-[0_0_18px_rgba(255,255,255,0.55)]" />
                <span className="absolute inset-y-[43%] inset-x-3 block rounded-full bg-white/45 shadow-[0_0_14px_rgba(255,255,255,0.33)]" />
                <span className="absolute -top-8 left-1/2 block h-10 w-10 sm:h-12 sm:w-12 -translate-x-1/2 rounded-full bg-gradient-to-r from-[#F5D4FF] via-[#C0B5FF] to-[#87A1FF] shadow-[0_20px_40px_rgba(118,78,255,0.35)]" />
                <span className="absolute -top-10 left-[32%] block h-6 w-6 sm:h-8 sm:w-8 rotate-12 rounded-[16px] bg-gradient-to-br from-[#FFE4FF] to-[#B0C6FF]" />
                <span className="absolute -top-10 right-[32%] block h-6 w-6 sm:h-8 sm:w-8 -rotate-12 rounded-[16px] bg-gradient-to-br from-[#FFE4FF] to-[#B0C6FF]" />
              </div>
              <div className="space-y-3">
                <h2 className="text-2xl sm:text-3xl font-semibold text-white">Discount 20% Off</h2>
                <p className="text-sm text-white/70">
                  Congrats! You earned a special reward on successful referral.
                </p>
              </div>
            </div>
          ) : (
            // ✅ Referral Form Card
            <div className="w-full max-w-sm sm:max-w-md">
              <div className="bg-[#0b0b0d] rounded-2xl p-6 sm:p-8 border border-gray-800 shadow-xl">

                {/* Heading */}
                <div className="text-center mb-6">
                  <h1 className="text-white text-2xl sm:text-3xl font-bold">
                    Referrer Link
                  </h1>
                  <p className="text-gray-400 text-sm mt-2">
                    Enter the referral link shared with you!
                  </p>
                </div>

                <form onSubmit={handleProceed}>
                  {/* Input */}
                  <div className="mb-4">
                    <label className="text-gray-300 text-sm mb-2 block font-medium">
                      Referrer Link
                    </label>
                    <input
                      type="text"
                      placeholder="Enter referral link"
                      value={refLink}
                      onChange={(e) => setRefLink(e.target.value)}
                      className="w-full bg-[#0b0b0d] border border-gray-700 rounded-md px-4 py-3 text-gray-200 placeholder-gray-500 focus:outline-none focus:border-purple-500 transition"
                    />
                  </div>

                  {/* Error */}
                  {error && (
                    <div className="mb-4 rounded-md border border-red-400/40 bg-red-500/10 px-4 py-2 text-sm text-red-300">
                      {error}
                    </div>
                  )}

                  {/* Buttons */}
                  <div className="flex gap-3">
                    <button
                      type="button"
                      onClick={handleSkip}
                      className="flex-1 bg-gray-700 hover:bg-gray-600 text-white py-3 rounded-lg transition"
                    >
                      Skip
                    </button>
                    <button
                      type="submit"
                      className="flex-1 bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg transition"
                    >
                      Proceed
                    </button>
                  </div>
                </form>
              </div>

              <p className="text-center text-gray-400 text-xs mt-6 px-6">
                By continuing, you agree to our Terms & Policies.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReferrerCapture;
